module.exports = __webpack_public_path__ + "static/media/selected_icn_map_event_block.8dede096.svg";